// Modules
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Pages
import { HomeComponent } from './core/pages/home/home.component';
import { LoginComponent } from './core/pages/login/login.component';
import { ErrorComponent } from './core/pages/error/error.component';
import { AllSupplyComponent } from './core/pages/supply/all-supply/all-supply.component';
import { SupplyByDayComponent } from './core/pages/supply/supply-by-day/supply-by-day.component';
import { SupplyByDomainComponent } from './core/pages/supply/supply-by-domain/supply-by-domain.component';
import { SupplyByDemandComponent } from './core/pages/supply/supply-by-demand/supply-by-demand.component';
import { ManageSupplyComponent } from './core/pages/supply/manage-supply/manage-supply.component';
import { NewSupplyComponent } from './core/pages/supply/new-supply/new-supply.component';
import { LegacyPublisherReportsComponent } from './core/pages/publishers/legacy-publisher-reports/legacy-publisher-reports.component';
import { PublishersReportAllComponent } from './core/pages/publishers/publishers-report-all/publishers-report-all.component';
import { AllDemandComponent } from './core/pages/demand/all-demand/all-demand.component';
import { DemandBySupplyComponent } from './core/pages/demand/demand-by-supply/demand-by-supply.component';
import { DemandByDayComponent } from './core/pages/demand/demand-by-day/demand-by-day.component';
import { DemandByDomainComponent } from './core/pages/demand/demand-by-domain/demand-by-domain.component';
import { ManageDemandComponent } from './core/pages/demand/manage-demand/manage-demand.component';
import { NewDemandComponent } from './core/pages/demand/new-demand/new-demand.component';
import { ReportComponent } from './shared/components/report/report.component';
// import { QualityAndViewabilityComponent } from './core/pages/quality/quality-and-viewability/quality-and-viewability.component';
// import { QualityBySupplyComponent } from './core/pages/quality/quality-by-supply/quality-by-supply.component';
// import { QualityByDemandComponent } from './core/pages/quality/quality-by-demand/quality-by-demand.component';
import { ManageCDNComponent } from './core/pages/cdn/manage-cdn/manage-cdn.component';
import { UsageCDNComponent } from './core/pages/cdn/usage-cdn/usage-cdn.component';
import { ManageListComponent } from './core/pages/list/manage-list/manage-list.component';
import { NewListComponent } from './core/pages/list/new-list/new-list.component';
import { ManagePublishersComponent } from './core/pages/publishers/manage-publishers/manage-publishers.component';
import { NewPublisherComponent } from './core/pages/publishers/new-publisher/new-publisher.component';
import { UserSettingsComponent } from './core/pages/settings/user-settings/user-settings.component';
import { NetworkSettingsComponent } from './core/pages/settings/network-settings/network-settings.component';
import { ContentEventsComponent } from './core/pages/content-events/content-events.component';
import { ManageCampaignsComponent } from './core/pages/campaigns/manage-campaigns/manage-campaigns.component';
import { NewCampaignComponent } from './core/pages/campaigns/new-campaign/new-campaign.component';
import { ManageRtbPartnersComponent } from './core/pages/rtb_partners/manage-rtb-partners/manage-rtb-partners.component';
import { NewRtbPartnerComponent } from './core/pages/rtb_partners/new-rtb-partner/new-rtb-partner.component';

// Guards
import { AuthGuard } from 'app/shared/guards/auth.guard';
import { ChangesGuard } from 'app/shared/guards/changes.guard';
import { UserTypeGuard } from 'app/shared/guards/user-type.guard';

// Routes
export const routes: Routes = [
  // Homepage
  { path: '', component: HomeComponent, pathMatch: 'full' },

  // Login
  { path: 'login', component: LoginComponent, pathMatch: 'full' },

  // Supply
  {
    path: 'supply/all',
    component: AllSupplyComponent,
    canActivate: [AuthGuard, UserTypeGuard],
    pathMatch: 'full',
    data: { userType: 'adv' },
  },
  {
    path: 'supply/by-demand',
    component: SupplyByDemandComponent,
    canActivate: [AuthGuard, UserTypeGuard],
    pathMatch: 'full',
    data: { userType: 'adv' },
  },
  {
    path: 'supply/by-day',
    component: SupplyByDayComponent,
    canActivate: [AuthGuard, UserTypeGuard],
    pathMatch: 'full',
    data: { userType: 'adv' },
  },
  {
    path: 'supply/by-domain',
    component: SupplyByDomainComponent,
    canActivate: [AuthGuard, UserTypeGuard],
    pathMatch: 'full',
    data: { userType: 'adv' },
  },
  {
    path: 'supply/manage',
    component: ManageSupplyComponent,
    canActivate: [AuthGuard, UserTypeGuard],
    pathMatch: 'full',
    data: { userType: 'adv' },
  },
  {
    path: 'supply/manage/:id',
    component: NewSupplyComponent,
    canActivate: [AuthGuard, UserTypeGuard],
    canDeactivate: [ChangesGuard],
    pathMatch: 'full',
    data: { duplicateMode: false, userType: 'adv', parentURI: 'supply/manage' },
  },
  {
    path: 'supply/duplicate/:id',
    component: NewSupplyComponent,
    canActivate: [AuthGuard, UserTypeGuard],
    canDeactivate: [ChangesGuard],
    pathMatch: 'full',
    data: { duplicateMode: true, userType: 'adv', parentURI: 'supply/manage' },
  },
  {
    path: 'supply/new',
    component: NewSupplyComponent,
    canActivate: [AuthGuard, UserTypeGuard],
    canDeactivate: [ChangesGuard],
    pathMatch: 'full',
    data: { userType: 'adv', parentURI: 'supply/manage' },
  },

  // Demand
  {
    path: 'demand/all',
    component: AllDemandComponent,
    canActivate: [AuthGuard, UserTypeGuard],
    pathMatch: 'full',
    data: { userType: 'adv' },
  },
  {
    path: 'demand/by-supply',
    component: DemandBySupplyComponent,
    canActivate: [AuthGuard, UserTypeGuard],
    pathMatch: 'full',
    data: { userType: 'adv' },
  },
  {
    path: 'demand/by-day',
    component: DemandByDayComponent,
    canActivate: [AuthGuard, UserTypeGuard],
    pathMatch: 'full',
    data: { userType: 'adv' },
  },
  {
    path: 'demand/by-domain',
    component: DemandByDomainComponent,
    canActivate: [AuthGuard, UserTypeGuard],
    pathMatch: 'full',
    data: { userType: 'adv' },
  },
  {
    path: 'demand/manage',
    component: ManageDemandComponent,
    canActivate: [AuthGuard, UserTypeGuard],
    pathMatch: 'full',
    data: { userType: 'adv' },
  },
  {
    path: 'demand/manage/:id',
    component: NewDemandComponent,
    canActivate: [AuthGuard, UserTypeGuard],
    canDeactivate: [ChangesGuard],
    pathMatch: 'full',
    data: { duplicateMode: false, userType: 'adv', parentURI: 'demand/manage' },
  },
  {
    path: 'demand/duplicate/:id',
    component: NewDemandComponent,
    canActivate: [AuthGuard, UserTypeGuard],
    canDeactivate: [ChangesGuard],
    pathMatch: 'full',
    data: { duplicateMode: true, userType: 'adv', parentURI: 'demand/manage' },
  },
  {
    path: 'demand/new',
    component: NewDemandComponent,
    canActivate: [AuthGuard, UserTypeGuard],
    canDeactivate: [ChangesGuard],
    pathMatch: 'full',
    data: { userType: 'adv', parentURI: 'demand/manage' },
  },

  // Reports
  {
    path: 'reports/new',
    component: ReportComponent,
    canActivate: [AuthGuard, UserTypeGuard],
    pathMatch: 'full',
    data: { isAdmin: false, userType: ['adv', 'cedatopub'] },
  },

  // More
  // {
  //   path: 'quality',
  //   component: QualityAndViewabilityComponent,
  //   canActivate: [AuthGuard, UserTypeGuard],
  //   pathMatch: 'full',
  //   data: { userType: 'adv' },
  // },
  // {
  //   path: 'quality/supply/:id',
  //   component: QualityBySupplyComponent,
  //   canActivate: [AuthGuard, UserTypeGuard],
  //   pathMatch: 'full',
  //   data: { userType: 'adv' },
  // },
  // {
  //   path: 'quality/demand/:id',
  //   component: QualityByDemandComponent,
  //   canActivate: [AuthGuard, UserTypeGuard],
  //   pathMatch: 'full',
  //   data: { userType: 'adv' },
  // },
  {
    path: 'cdn/manage',
    component: ManageCDNComponent,
    canActivate: [AuthGuard, UserTypeGuard],
    data: { featureFlag: 'display_cdn', userType: 'adv' },
    pathMatch: 'full',
  },
  {
    path: 'cdn/usage',
    component: UsageCDNComponent,
    canActivate: [AuthGuard, UserTypeGuard],
    data: { featureFlag: 'display_cdn', userType: 'adv' },
    pathMatch: 'full',
  },
  {
    path: 'publishers/manage',
    component: ManagePublishersComponent,
    canActivate: [AuthGuard, UserTypeGuard],
    pathMatch: 'full',
    data: { userType: 'adv' },
  },
  {
    path: 'publishers/manage/:id',
    component: NewPublisherComponent,
    canActivate: [AuthGuard, UserTypeGuard],
    canDeactivate: [ChangesGuard],
    pathMatch: 'full',
    data: { userType: 'adv', parentURI: 'publishers/manage' },
  },
  {
    path: 'publishers/new',
    component: NewPublisherComponent,
    canActivate: [AuthGuard, UserTypeGuard],
    canDeactivate: [ChangesGuard],
    pathMatch: 'full',
    data: { userType: 'adv', parentURI: 'publishers/manage' },
  },
  {
    path: 'list/manage',
    component: ManageListComponent,
    canActivate: [AuthGuard, UserTypeGuard],
    pathMatch: 'full',
    data: { userType: 'adv' },
  },
  {
    path: 'list/manage/:id',
    component: NewListComponent,
    canActivate: [AuthGuard, UserTypeGuard],
    canDeactivate: [ChangesGuard],
    pathMatch: 'full',
    data: { userType: 'adv', parentURI: 'list/manage' },
  },
  {
    path: 'list/new',
    component: NewListComponent,
    canActivate: [AuthGuard, UserTypeGuard],
    canDeactivate: [ChangesGuard],
    pathMatch: 'full',
    data: { userType: 'adv', parentURI: 'list/manage' },
  },
  {
    path: 'campaigns/manage',
    component: ManageCampaignsComponent,
    canActivate: [AuthGuard, UserTypeGuard],
    pathMatch: 'full',
    data: { featureFlag: 'manage_campaigns', userType: 'adv' },
  },
  {
    path: 'campaigns/manage/:id',
    component: NewCampaignComponent,
    canActivate: [AuthGuard, UserTypeGuard],
    canDeactivate: [ChangesGuard],
    pathMatch: 'full',
    data: { featureFlag: 'manage_campaigns', userType: 'adv' },
  },
  {
    path: 'campaigns/new',
    component: NewCampaignComponent,
    canActivate: [AuthGuard, UserTypeGuard],
    canDeactivate: [ChangesGuard],
    pathMatch: 'full',
    data: { featureFlag: 'manage_campaigns', userType: 'adv' },
  },
  {
    path: 'rtb-partners/manage',
    component: ManageRtbPartnersComponent,
    canActivate: [AuthGuard, UserTypeGuard],
    pathMatch: 'full',
    data: { featureFlag: 'rtb_demand', userType: 'adv' },
  },
  {
    path: 'rtb-partners/manage/:id',
    component: NewRtbPartnerComponent,
    canActivate: [AuthGuard, UserTypeGuard],
    canDeactivate: [ChangesGuard],
    pathMatch: 'full',
    data: { featureFlag: 'rtb_demand', userType: 'adv' },
  },
  {
    path: 'rtb-partners/new',
    component: NewRtbPartnerComponent,
    canActivate: [AuthGuard, UserTypeGuard],
    canDeactivate: [ChangesGuard],
    pathMatch: 'full',
    data: { featureFlag: 'rtb_demand', userType: 'adv' },
  },
  {
    path: 'content/reports',
    component: ContentEventsComponent,
    canActivate: [AuthGuard, UserTypeGuard],
    canDeactivate: [ChangesGuard],
    pathMatch: 'full',
    data: { isAdmin: false, userType: 'adv', labsVer: 2, reportType: 'content_reports', injectedDimensions: [26] },
  },

  // Admin
  { path: 'admin', loadChildren: './features/admin/admin.module#AdminModule' },

  // Settings
  {
    path: 'settings/user',
    component: UserSettingsComponent,
    canActivate: [AuthGuard, UserTypeGuard],
    pathMatch: 'full',
    data: { userType: 'adv' },
  },
  {
    path: 'settings/network',
    component: NetworkSettingsComponent,
    canActivate: [AuthGuard, UserTypeGuard],
    canDeactivate: [ChangesGuard],
    pathMatch: 'full',
    data: { userType: 'adv' },
  },

  //Publishers
  {
    path: 'inventory-all',
    component: LegacyPublisherReportsComponent,
    canActivate: [AuthGuard],
    pathMatch: 'full',
    data: {},
  },
  {
    path: 'inventory/all',
    component: PublishersReportAllComponent,
    canActivate: [AuthGuard],
    pathMatch: 'full',
    data: { labsVer: 2 },
  },
  {
    path: 'domain/all',
    component: PublishersReportAllComponent,
    canActivate: [AuthGuard],
    pathMatch: 'full',
    data: { labsVer: 2 },
  },

  // Error
  { path: '**', component: ErrorComponent },
];

// ngModule
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
